import React from "react";
import { useRouteError, useNavigate } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";
// import "./RouterErrorPageCss.css";

const RouterErrorPage = () => {
  const error = useRouteError();
  const navigate = useNavigate();
  const message = error?.message ?? error?.statusText ?? "An unexpected error occurred";
  const status = error?.status;

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        p: 3,
        bgcolor: "#f5f5f5",
      }}
    >
      <Typography variant="h5" sx={{ mb: 1, fontWeight: 600 }}>
        {status ? `Error ${status}` : "Something went wrong"}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2, textAlign: "center" }}>
        {message}
      </Typography>
      <Button variant="contained" onClick={() => navigate(-1)}>
        Go back
      </Button>
    </Box>
  );
};

export default RouterErrorPage;
